import type * as Types from '~/gql/graphql';

import { gql } from 'urql';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type FilesFoldersNavigatorsData_FolderFragment = { id: string, name: string, drive_folder_mapping?: { id: string } | null };

export type FilesFoldersNavigatorsData_FileFragment = { id: string, name: string, extension?: string | null, due_date?: string | null, drive_file_mapping?: { id: string } | null, last_version?: Array<{ id: string, created_at: string, updated_at: string, size?: number | null, url?: string | null, creator: { full_name?: string | null, user_avatar?: { public_url: string } | null } }> | null };

export type GetFilesFoldersNavigatorQueryVariables = Types.Exact<{
  folder_id: Types.Scalars['uuid']['input'];
}>;


export type GetFilesFoldersNavigatorQuery = { folders_by_pk?: { id: string, name: string, parents_ids?: any | null, folders: Array<{ id: string, name: string, drive_folder_mapping?: { id: string } | null }>, files: Array<{ id: string, name: string, extension?: string | null, due_date?: string | null, drive_file_mapping?: { id: string } | null, last_version?: Array<{ id: string, created_at: string, updated_at: string, size?: number | null, url?: string | null, creator: { full_name?: string | null, user_avatar?: { public_url: string } | null } }> | null }> } | null };

export type GetProjectFileRootQueryVariables = Types.Exact<{
  project_id: Types.Scalars['uuid']['input'];
}>;


export type GetProjectFileRootQuery = { projects_by_pk?: { id: string, root_bin_folder_id?: string | null, root_folder_id?: string | null } | null };

export const FilesFoldersNavigatorsData_FolderFragmentDoc = gql`
    fragment FilesFoldersNavigatorsData_folder on folders {
  id
  name
  drive_folder_mapping {
    id
  }
}
    `;
export const FilesFoldersNavigatorsData_FileFragmentDoc = gql`
    fragment FilesFoldersNavigatorsData_file on files {
  id
  name
  drive_file_mapping {
    id
  }
  extension
  due_date
  last_version {
    id
    created_at
    updated_at
    size
    url
    creator {
      full_name
      user_avatar {
        public_url
      }
    }
  }
}
    `;
export const GetFilesFoldersNavigatorDocument = gql`
    query GetFilesFoldersNavigator($folder_id: uuid!) {
  folders_by_pk(id: $folder_id) {
    id
    name
    folders {
      ...FilesFoldersNavigatorsData_folder
    }
    files {
      ...FilesFoldersNavigatorsData_file
    }
    parents_ids
  }
}
    ${FilesFoldersNavigatorsData_FolderFragmentDoc}
${FilesFoldersNavigatorsData_FileFragmentDoc}`;

export function useGetFilesFoldersNavigatorQuery(options: Omit<Urql.UseQueryArgs<GetFilesFoldersNavigatorQueryVariables>, 'query'>) {
  return Urql.useQuery<GetFilesFoldersNavigatorQuery, GetFilesFoldersNavigatorQueryVariables>({ query: GetFilesFoldersNavigatorDocument, ...options });
};
export const GetProjectFileRootDocument = gql`
    query GetProjectFileRoot($project_id: uuid!) {
  projects_by_pk(id: $project_id) {
    id
    root_bin_folder_id
    root_folder_id
  }
}
    `;

export function useGetProjectFileRootQuery(options: Omit<Urql.UseQueryArgs<GetProjectFileRootQueryVariables>, 'query'>) {
  return Urql.useQuery<GetProjectFileRootQuery, GetProjectFileRootQueryVariables>({ query: GetProjectFileRootDocument, ...options });
};